import React, { useState } from "react";
import { useEffect } from "react";
import { Spinner } from "reactstrap";

const AdminDashboardCount = ({ ...props }) => {
  const [Edit, setEdit] = useState([]);
  const [submit, setsubmit] = useState([]);
  const [Lorder, setLorder] = useState(true);
  const getdata = async () => {
    const sendData = {
      UserId: Number(props.userid),
      Apikey1: String(props.fromyear),
      Apikey2: String(props.toyear),
    };
    await fetch(process.env.REACT_APP_API_LINK + "api/NCSCDA/DashboardData", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sendData),
    })
      .then((response) => response.json())
      .then((data) => {
        const edit = data.filter((a) => a.activeStatus === "A");
        const sub = data.filter((a) => a.activeStatus === "S");
        setEdit(edit);
        setsubmit(sub);
        setLorder(false);
      });
  };

  useEffect(() => {
    setLorder(true);
    getdata();
  }, [props.userid, props.fromyear, props.toyear]);

  return Lorder ? (
    <Spinner color="success" />
  ) : (
    <>
      <td>
        {" "}
        <b style={{ fontSize: 18 }}> {Edit.length}</b>
      </td>
      <td>
        {" "}
        <b style={{ fontSize: 18 }}>{submit.length}</b>
      </td>
    </>
  );
};

export default AdminDashboardCount;
